import { call, takeEvery, all, SagaReturnType } from 'redux-saga/effects';
import { resolvePromiseAction, rejectPromiseAction } from '@teroneko/redux-saga-promise';

import { loadContracts, loadContractPayouts, loadCashFlows, loadCalculationParameters, downloadContractOplataExcel } from 'api/contracts';
import { 
  loadContractsAction, 
  loadContractPayoutsAction,
  loadCashFlowsAction,
  loadCalculationParametersAction,
  loadDownloadExcelAction,
} from './contracts.reducer';

function* loadContractsFlow(action: typeof loadContractsAction.types.triggerAction) {
  try {
    const { data }: SagaReturnType<typeof loadContracts> = yield call(loadContracts, action.payload);
    yield call(resolvePromiseAction, action, data);
  } catch (error: any) {
    yield call(rejectPromiseAction, action, error);
  }
}

function* loadContractPayoutsFlow(action: typeof loadContractPayoutsAction.types.triggerAction) {
  try {
    const { data: payouts }: SagaReturnType<typeof loadContractPayouts> = yield call(loadContractPayouts, action.payload);
    yield call(resolvePromiseAction, action, payouts);
  } catch (error: any) {
    yield call(rejectPromiseAction, action, error);
  }
}

function* loadCashFlowsFlow(action: typeof loadCashFlowsAction.types.triggerAction) {
  try {
    const { data }: SagaReturnType<typeof loadCashFlows> = yield call(loadCashFlows, action.payload);
    yield call(resolvePromiseAction, action, data);
  } catch (error: any) {
    yield call(rejectPromiseAction, action, error);
  }
}


function* loadCalculationParametersFlow(action: typeof loadCalculationParametersAction.types.triggerAction) {
  try {
    const { data }: SagaReturnType<typeof loadCalculationParameters> = yield call(loadCalculationParameters, action.payload);
    yield call(resolvePromiseAction, action, data);
  } catch (error: any) {
    yield call(rejectPromiseAction, action, error);
  }
}

function* loadDownloadExcelFlow(action: typeof loadDownloadExcelAction.types.triggerAction) {
  try {
    const { data }: SagaReturnType<typeof downloadContractOplataExcel> =
      yield call(downloadContractOplataExcel, action.payload);
    yield call(resolvePromiseAction, action, data);
  } catch (error: any) {
    yield call(rejectPromiseAction, action, error);
  }
}

export default function* contractsSaga() {
  yield all([
    takeEvery(loadContractsAction, loadContractsFlow),
    takeEvery(loadContractPayoutsAction, loadContractPayoutsFlow),
    takeEvery(loadCashFlowsAction, loadCashFlowsFlow),
    takeEvery(loadCalculationParametersAction, loadCalculationParametersFlow),
    takeEvery(loadDownloadExcelAction, loadDownloadExcelFlow),
  ]);
}
